<script>
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import {h, resolveComponent} from "vue";

export default {
  name: 'widgetFreeTrial',
  components: {widgetWrapper},
  emits: ['more'],
  render() {
    const {$theme, items} = this;
    const {title, subtitle, desc, dateItem, more, info} = items;
    const legoIcon = resolveComponent('lego-icon')
    const widgetWrapper = resolveComponent('widget-wrapper');
    const widgetFreeDescList = desc.map(descVal => {
      return h('li', [
        h(legoIcon, {
          iconType: 'df',
          icon: 'check',
          size: 16,
        }),
        descVal,
      ]);
    });

    const widgetFreeDesc = h('ul', {class: 'widget-ft-desc'}, widgetFreeDescList);

    const widgetFreeTrial = h('div', {class: 'widget-ft'}, [this.$slots.wbody(), widgetFreeDesc]);

    return h(
        widgetWrapper,
        {
          title, subtitle, dateItem, more, info,
          onMore: more => {
            this.$emit('more', more);
          },
        },
        () => [widgetFreeTrial],
    );
  },
  methods: {},
  props: {
    items: {
      type: Object,
      default: () => {
      },
    },
    desc: {
      type: Array,
      default: () => {
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.widget-ft {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  @include font(16px);

  &-desc {
    border-top: 1px solid $color--ui08;
    padding: 12px 20px 0;
    margin-top: 32px;

    li {
      display: flex;
      align-items: center;
      margin-top: 8px;

      :deep .lego-icon {
        margin-right: 12px;
        vertical-align: middle;
      }
    }
  }
}
</style>
